module.exports = __webpack_public_path__ + "img/filter_2.41853f64.svg";